import { alpha, useTheme } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { mixHexColors } from '@tyro/core/utils';

export type PanelTabsProps = {
  componentId: string;
  tabs: {
    key: 'needToKnow' | 'timeline' | 'personalInfo';
    id: string;
    name: string;
    panelId: string;
  }[];
  value: string;
  setTab: (key: string) => void;
};

export function PanelTabs({ tabs, value, setTab }: PanelTabsProps) {
  const { palette } = useTheme();

  return (
    <Tabs
      value={value}
      onChange={(_, newValue) => setTab(newValue)}
      variant="fullWidth"
      sx={{
        top: 0,
        left: 0,
        zIndex: 1,
        width: '100%',
        minHeight: 'auto',
        backgroundColor: mixHexColors(palette.indigo[50], '#fff', 0.3),

        '& .MuiTabs-scroller': {
          backgroundColor: alpha(palette.slate[500], 0.05),
          borderRadius: 1,
        },

        '& .MuiTabs-indicator': {
          backgroundColor: 'transparent',
          height: '100%',

          ':after': {
            content: '""',
            position: 'absolute',
            top: 2,
            left: 2,
            width: 'calc(100% - 4px)',
            height: 'calc(100% - 4px)',
            borderRadius: '7px',
            backgroundColor: 'white',
          },
        },

        '& .MuiTab-root': {
          fontSize: 13,
          fontWeight: 700,
          position: 'relative',
          zIndex: 1,

          '&:not(:last-of-type)': {
            mr: 2,
          },

          '&.Mui-selected': {
            color: 'primary.main',
          },
        },
        '&:has(.MuiTabScrollButton-root)': {
          px: 0,
        },
      }}
    >
      {tabs.map((tab) => (
        <Tab
          key={tab.key}
          id={tab.id}
          value={tab.key}
          label={tab.name}
          aria-controls={tab.panelId}
          sx={{
            minHeight: 40,
          }}
        />
      ))}
    </Tabs>
  );
}
